import { logError } from '@ff-os/shared-utils/logging';
import { IDT } from '../IDT';

let bindings: IDT.Events = {
    order: (e: IDT.OrderEvent) => logError('No order event handler configured.', e),
    pricing: () => {},
    focus: () => {},
    load: () => {}
};

export const bindSiteEvents = (events: IDT.Events) => {
    bindings = { ...bindings, ...events };
};

export const fireOrderEventToSite = (e: IDT.OrderEvent) => {
    return bindings.order(e) ?? Promise.resolve();
};

export const firePricingEventToSite = (e: IDT.PricingEvent) => {
    bindings.pricing(e);
};

export const fireFocusEventToSite = (e: IDT.FocusEvent) => {
    bindings.focus(e);
};

export const fireLoadEventToSite = (e: IDT.LoadEvent) => {
    bindings.load(e);
};